<template>
    <div class="col-12">
        <div class="row form-inline">
            <!-- <div class="my-1 mr-2" style="margin-right: 5px;margin-left: 15px;">
                <label for="contractCheck">Include this document?</label>
            </div>
            <div class="custom-control custom-checkbox my-1 mr-sm-2">
                <input type="checkbox" class="custom-control-input" id="contractCheck" v-model="form.checked" @change="setUpdate"/>
                <label class="custom-control-label" for="contractCheck">Yes</label>
            </div> -->
            <div class="my-1 mr-2" style="margin-left: 15px;">
                <label for="signe">Request Digital Signature?</label>
            </div>
            <div class="custom-control custom-checkbox my-1 mr-sm-2">
                <input type="checkbox" class="custom-control-input" id="signe" v-model="form.signe" @change="setUpdate"/>
                <label class="custom-control-label" for="signe">Yes</label>
            </div>
        </div>
        <div class="form-inline row">
            <input type="text" class="form-control" style="margin-right: 5px;margin-left: 15px;margin-bottom:0px;width:100%;max-width:460px;" v-model="selectCTemplate.title" placeholder="Terms & Conditions" />
            <select v-model="selectedContract" class="form-control my-1 mr-2" style="margin-top: 10px;width:100%;max-width:470px;">
                <option :value="contractTemplateDefault" :selected="selectedContract.id == contractTemplateDefault.id">
                    Select template
                </option>
                <option v-for="(i, index) in ContractTemLists" :key="index" :value="i" :selected="selectedContract.id == i.id">
                    {{ i.title }}
                    <span v-if="i.alias !== null"> - {{ i.alias }}</span>
                </option>
            </select>
        </div>
        <div class="col-12" id="contractEditor">
            <div class="bgAgua" :style="Showlogo > 0 ? {'background-image': bgAgua} : {}"></div>
            <table style="width:750px; padding-top:0px;  border: 0px dashed orange; display:none;">
                <tr>
                    <td>
                        <table>
                            <tr>
                                <td valign="top" style="width:60%; max-width: 200px; padding: 3px 15px; padding-right: 10px; border: 0px dashed blue;">
                                    <div style="width:150px; height:90px; position: relative; text-align: center; border: 0px solid #000; margin:0px auto;">
                                        <img style="border: 0px solid red;" :src="logo" alt="logo" width="150" height="auto" v-if="Showlogo">
                                    </div>
                                </td>
                                <td style="line-height: 1.3; font-size:12px; color:#555;">
                                    {{getorginfo.bill_company_name}} <br />
                                    {{getorginfo.bill_address}} <br />
                                    {{getorginfo.bill_city}}, {{getorginfo.bill_state}} {{getorginfo.bill_zip_code}} <br />
                                    {{getorginfo.bill_telephone}} <br />
                                    {{getorginfo.bill_email}} <br />
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td valign="top" style="width:35%;border: 0px dashed blue;">
                        <h4 style="color:#555;margin:0; padding:0;text-align:right;display: block; font-size:25px;margin-bottom:2px;font-weight: normal;"> Estimate #{{ numDoc }}</h4>
                        <span style="text-align:right;display: block;font-size:14px;">
                        Date: {{ showDateCreated || '' }}<br />
                        </span>
                    </td>
                </tr>
            </table>
            <h3 style="text-align:center; font-size:23px;color:#000; font-weight:bold; margin-top:20px;">{{ selectCTemplate.title }}</h3>
            <vue-editor v-model="selectCTemplate.description" @text-change="setUpdate" :editor-toolbar="customToolbar" class="editorContract" :placeholder="placeholcelderText"/>
            <h5 style="padding-top: 20px" ></h5>
            <div class="row" >
                <div class="col-1"></div>
                <div class="col-5">
                    <!-- <h4> Signature Receiver:</h4> -->
                    <div class="form-group row">
                        <!-- <label class="col-sm-2 col-form-label">Customer</label> -->
                        <div class="col-sm-10">
                            <div id="previewSign2" class="fontStyle5"></div>
                            <input type="text" class="form-control" v-model="form.customer_name" @change="setUpdate"
                            style="text-align: center; border:0; border-radius: 0; background: transparent; font-weight:bold; color:#000; padding-bottom: 0; font-size: 16px;"/>
                            <div :class="['', (disabledSteps.customer) ? 'disabled' : '']" style="text-align: center;">
                                {{ FormSignature.dateCustomer | moment("MMM DD, YYYY") }}
                            </div>
                            <input type="text" class="form-control" v-model="FormSignature.dateCustomer" required="true"
                                disabled style="display:none;" />
                        </div>
                    </div>
                </div>
                <div class="col-5">
                    <!-- <h4>Signature Submitter:</h4> -->
                    <div class="form-group row text-left">
                        <!-- <label class="col-sm-2 col-form-label">Company</label> -->
                        <div class="col-sm-10">
                            <div id="previewSign" class="fontStyle5" v-if="signature!=null">{{signature}}</div>
                            <input type="text" class="form-control" v-model="FormSignature.nameCompany" @change="setUpdate"
                            style="text-align: center; border:0; border-radius: 0; background: transparent; font-weight:bold; color:#000; padding-bottom: 0; font-size: 16px;"/>
                            <div :class="['', (disabledSteps.customer) ? 'disabled' : '']" style="text-align: center;">
                                {{ FormSignature.dateCompany | moment("MMM DD, YYYY") }}
                            </div>
                            <input type="text" class="form-control" v-model="FormSignature.dateCompany" required="true"
                                disabled style="display:none;" @change="setUpdate"/>
                        </div>
                    </div>
                </div>
                <div class="col-1"></div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment';
import { VueEditor } from 'vue2-editor'
import './needAcontract.scss';
export default {
    components: {
        VueEditor,
    },
    props: [
        "propForm",
        "propdisabledSteps",
        "propFormSignature",
        "propSelectCTemplate",
    ],
    data() {
        return {
            ContractTemLists: [],
            disabledSteps: this.propdisabledSteps,
            form: this.propForm,
            FormSignature: this.propFormSignature,
            selectCTemplate: this.propSelectCTemplate,
            prevSelectCTemplate: this.propSelectCTemplate,
            PlanPremium: true,
            contractTemplateDefault: { id: 0, title: 'Contract Title', description: '' },
            selectedContract: { id: 0, title: 'Contract Title', description: '' },
            contractCustom: false,
            customToolbar: [
                [
                    { header: [1, 2, 3, 4, 5, 6, false] },
                    "bold", "italic", "underline", "strike",
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" },
                    { list: "ordered" },
                    { list: "bullet" },
                    { color: [] },
                    "link",
                    // "image",
                    "clean"
                ]
            ],
            Showlogo: false,
            logo: '',
            bgAgua: '',
            placeholcelderText: 'Write the content of the letter here...',
            fontStyle: 5,
            showSign: 0,
            signature: this.propFormSignature.nameCompany,
        };
    },
    created(){
        let t = this;
        // t.PlanPremium = (t.$store.getters['core/Org/getPlanId'] > 1);
        t.getCTemplates();
        t.getLogo();
        t.getSignature();
    },
    mounted(){
        let t = this;
        // Selecciona el elemento que quieres observar
        const target = document.querySelector('#contractEditor .quillWrapper .ql-editor');
        const headerToolBarEditor = document.querySelector('#contractEditor .quillWrapper .ql-snow.ql-toolbar');
        // Crea el observador
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                console.log('✅ La sección está visible en pantalla');
                // Aquí puedes disparar tu evento o acción:
                    headerToolBarEditor.classList.add('toFix');
                } else {
                    console.log('⛔ La sección salió de la vista');
                    headerToolBarEditor.classList.remove('toFix');
                }
            });
        }, {
            root: null, // viewport
            threshold: 0.3 // porcentaje visible (0.3 = 30%)
        });
        // Empieza a observar
        observer.observe(target);
    },
    methods: {
        getCTemplates() {
            // window.billing
            window.billingSales
            .get("contracttemplate/" + window.localuserdata)
            .then((response) => {
                // console.log("template estimates list", response.data);
                this.ContractTemLists = response.data.result;
            })
            .catch((error) => {
                console.log(error);
            });
        },
        setUpdate(){
            // if(!this.form.checked) {this.form.signe = false;}
            this.$emit('updateContract', {
                "FormSignature": this.FormSignature,
                "selectCTemplate": this.selectCTemplate,
                "includeContract": this.form.checked,
                "signe": this.form.signe,
                "customer_name": this.form.customer_name,
            });
        },
        getLogo() {
            let t= this;
            window.master
            .get("bg/logo/" + window.localuserdata + "/" + +window.master_client)
            .then((response) => {
                console.log(response.data);
                t.Showlogo = response.data.Showlogo;
                t.logo = response.data.logo;
                t.bgAgua = "url";
                t.bgAgua += "(";
                t.bgAgua += response.data.logo;
                t.bgAgua += ")";
                console.log("bg/logo/", t.bgAgua);
                //t.getBgs();
            })
            .catch((error) => {
                console.log(error);
            });
        },
        getSignature() {
			let t = this;
			window.master.post("getSignature", {
				user_id: window.master_client,
				org_id: window.localorgdata,
			})
			.then((response) => {
				console.log(response.data);
				if(response.data.status){
					let val = JSON.parse(response.data.r.meta_value);
					if(val){
						t.fontStyle = val.fontStyle || 5;
						t.showSign = val.showSign || 0;
                        t.signature = val.signature;
					}
				}
				setTimeout(function(){
					let previewSign = document.querySelector("#previewSign");
                    if(!previewSign) return;
                    if(previewSign.classList.length>0) {
                        previewSign.removeAttribute('class');
                    }
                    previewSign.classList.add('fontStyle'+t.fontStyle);
			}, 1000);
			})
			.catch((error) => {
				console.log(error);
			});
		},
    },
    watch: {
        selectCTemplate: {
            handler: function(newVal){
                let t = this;
                t.selectedContract = newVal;
                const isChoose = t.ContractTemLists.some(item => item.description === newVal.description);
                // console.log('isChoose', isChoose)
                if(!isChoose){
                    // si entra en esta condicion quiere decir q no ha seleccionando ningun contrato de la lista o lo ha personalizado
                    t.contractCustom=true;
                    t.selectedContract = t.contractTemplateDefault; // para no mostrar el select en blanco asigno un valor default
                }
            },
            deep: true, // Necesario para observar cambios en los objetos dentro del array
            immediate: true, // Llamar al watch inmediatamente al cargar
        },
        selectedContract: function(){
            let t = this;
            if(t.selectedContract.description != t.contractTemplateDefault.description){
                t.selectCTemplate.description = t.selectedContract.description;
            }else{
                t.selectCTemplate.description = t.prevSelectCTemplate.description;
            }
        },
        getPlanId() {
            this.PlanPremium = (this.$store.getters['core/Org/getPlanId'] > 1);
            // console.log('watch PlanPremium', this.PlanPremium);
        },
    },
    computed: {
        ...mapGetters("core/Org", { getPlanId: "getPlanId"}),
        ...mapGetters("core/Org", {getorginfo: "orginf"}),
        numDoc: function() {
            const num = this.form?.numdoc ?? '';
            return String(num).padStart(4, '0');
        },
        showDateCreated() {
            if(this.form.actionNname == 'create'){
                return new Date().toLocaleDateString("en-US", { year: "numeric", month: "short", day: "2-digit" });
            }
            let dateValue = this.form?.date_created;
            if (!dateValue || dateValue.length < 10) {
                return new Date().toLocaleDateString("en-US", { year: "numeric", month: "short", day: "2-digit" });
            }
            // console.log('date_created', dateValue)
            let dateSinHoras = (typeof dateValue === 'string' && dateValue.includes('T')) ? dateValue.split('T')[0] : dateValue;
            // let parts = dateSinHoras.split("-");
            // console.log('parts', parts);
            let date = new Date(dateSinHoras); // YYYY-MM-DD
            return date.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "2-digit" }); // formato corto, Feb 1, 2021
        },
    },
};
</script>
<style scoped>
@import url("./../../../../../core/assets/css/firmas.css");
</style>